export default {
    answered: 'Answered',
    attempted: 'Attempted',
    calling: 'Calling',
    delivered: 'Delivered',
    delivery_failed: 'Delivery failed',
    error: 'Error',
    failed: 'Failed',
    interrupted: 'Interrupted',
    invalid: 'Invalid',
    pending: 'Pending',
    read: 'Read',
    sent: 'Sent',
    unanswered: 'Unanswered',
    unread: 'Unread',
};
